<template>
  <div>
    <div class="banner">
      <h4>{{form.id ? "Editar Tipo de Anexo" : "Cadastro de Tipo de Anexo" }}</h4>
    </div>

    <v-form @submit.prevent="save" ref="form">
      <v-row>
        <v-col cols="12"> 
          <v-text-field
            v-model="form.name"
            label="Informe o Tipo de Anexo*"
            class="rounded-lg"
            outlined
            dense
            color="#41916b"
            :rules="formRules"
          />
        </v-col>
      </v-row>

      <v-card-actions class="cardFooter">
        <v-spacer></v-spacer> 
        <v-btn
          class="rounded-lg"
          color="#e74c3c"
          text
          elevation="0"
          @click="closeDialog()"
        >
          <span>{{$t('buttons.cancel')}}</span>
        </v-btn> 
        <v-btn
          class="rounded-lg"
          color="blue"
          text
          elevation="0"
          @click="clearForm"
        >
          <span>{{$t('buttons.clean_up')}}</span>
        </v-btn> 
        <v-btn
          color="#41916b"
          dark
          class="rounded-lg mr-3"
          type="submit"
          :loading="loading"
        > 
          {{ form.id ? "Atualizar" : "Salvar" }}
        </v-btn>
      </v-card-actions>
    </v-form>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import axios from "@/axios";

export default {
  props: {
    resource: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      loading: false,
      formRules: [
        (v) => !!v || "Campo obrigatório."
    ],
      options: {},
      sortBy: "name",

      form: {
        id: null,
        name: "",
      },
      message: "",
    };
  },

  watch:{
    resource:{
      immediate: true,
      deep:true,

      handler(value){
        if(value){
          this.form.id = value.id || null;
          this.form.name = value.name || "";
        }
      }
    }
  },

  methods: {
    ...mapActions(["changeSnackBarData"]),

    save() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        const dados = {
            name:this.form.name
        }

        axios({
          method: this.form.id ? "PUT" : "POST",

          url: this.form.id
            ? `attachments_type/${this.form.id}`
            : `attachments_type`,

          data: dados,
        })
          .then((response) => {
            this.message = response.data.message;
            this.changeSnackBarData({
              status: true,
              type: "success",

              titleMessage: this.form.id
                ? "Tipo de anexo atualizado com sucesso!"
                : "Tipo de anexo cadastrado com sucesso!",

              bodyMessage: "",
              cardColor: "#41916b",
              titleIcon: "mdi-checkbox-marked-circle",
            });

            this.$emit("updateGrid");
            this.closeDialog();
            this.clearForm();

            setTimeout(() => {
              this.closeSnackBar();
            }, 3000);
          })
          .catch(() => {
            this.changeSnackBarData({
              status: true,
              type: "error",
              titleMessage:
             "Erro ao salvar registro",
              bodyMessage: "",
              cardColor: "red",
              titleIcon: "mdi-close-circle",
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    clearForm() {
      this.form = {
        id: null,
        name: "",
      };

      this.$refs.form.resetValidation();
    },

    closeDialog() {
      this.$emit("closeDialog");
    },

    closeSnackBar() {
      this.changeSnackBarData({
        status: false,
        type: "",
        titleMessage: "",
        bodyMessage: "",
        cardColor: "",
        titleIcon: "",
      });
    },
  },
};
</script>

<style scoped>
.header-table {
  display: flex;
  margin-bottom: 20px;
}

.space {
  width: 15px;
}

.spacediferent {
  width: 7px;
}

.unity {
  font-size: 12px;
}

.v-btn:not(.v-btn--round).v-size--default {
  height: 40px !important;
}

.v-card__title {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0.0125em;
  font-family: "Roboto";
}

.textBtn {
  font-family: "Poppins";
  color: #ffffff;
}

.create-user-dialog {
  padding: 20px;
}

.card {
  padding: 35px;
}

.banner {
  background: #b3ffab;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right, #41916b, #1abc9c);
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right, #41916b, #b8e0cd);
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

  border-radius: 8px;

  margin-bottom: 20px;

  display: flex;
  align-items: center;
}

.banner > h4 {
  color: #ffffff;
  padding: 10px;
}

.cardFooter {
  padding: 0 !important;
}
</style>
